import { Link, TableCell, TableRow, useTheme } from "@mui/material"
import { ContextMenuBar } from "lib/@components/context-menu-bar"
import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import {
    bodyCellPinnedStyle,
    stickyActionCellSx,
} from "routes/asset-register/plugins/regime-display/asset-view-table/asset-view-pinned-cell-styles"
import { updateAssetRegister } from "routes/asset-register/controller/update-asset-register"
import { confirm } from "lib/@dialogs/confirm"
import { noChange, useRefresh } from "lib/@hooks/useRefresh"
import { BlockClicks } from "lib/@components/block-clicks"
import { navigate } from "lib/routes/navigate"
import { Secure } from "lib/authorization/secure"
import { busyWhile } from "lib/@components/busy/busy-while"
import { Feature } from "lib/@components/feature"
import { Repeat } from "lib/@components/repeat"
import { AssetField } from "routes/asset-register/plugins/regime-display/asset-field"
import { uniqueId } from "library/database/split-id.mjs"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useMemo } from "react"
import { formatDatesInAssetOrTask } from "./plugins/regime-display/format-dates-in-asset-or-task"
import { DATE_FORMATS } from "lib/@constants/date-format"
import { pick } from "lib/pick"
import { usePlanRoot } from "lib/use-plan-root"
import { If } from "lib/@components/switch.js"

export function AssetEntry({ item, register, canEdit = true }) {
    const { refresh } = useRefresh(noChange)
    const { displayFields } = useBoundContext()
    const regime = usePlanRoot()
    const theme = useTheme()

    useMemo(() => {
        formatDatesInAssetOrTask(item, DATE_FORMATS.medium)
    }, [item])
    return (
        <TableRow data-cy="asset-entry-row">
            <TableCell data-cy="asset-tag-cell-content" sx={{ minWidth: 200, ...bodyCellPinnedStyle(true, theme) }}>
                <Link onClick={editAsset}>{item.tag}</Link>
            </TableCell>
            <TableCell data-cy="asset-description-cell-content">{item.description}</TableCell>
            <TableCell data-cy="asset-type-cell-content">{item.type}</TableCell>
            <Repeat keyFn={pick("field")} list={displayFields} item={<AssetField asset={item} />} />
            <Feature feature="edit-assets">
                <If value={canEdit}>
                    <TableCell sx={stickyActionCellSx(theme)}>
                        <BlockClicks>
                            <Secure demand="manageRegime">
                                <ContextMenuBar
                                    type="asset-register-row"
                                    label={`More actions for ${item.tag || "this asset"}`}
                                >
                                    <ContextMenuItem
                                        icon="mdi:delete"
                                        label={`Delete ${item.type || "Asset"}`}
                                        onClick={removeAsset}
                                        data-cy="remove-asset-btn"
                                    />
                                </ContextMenuBar>
                            </Secure>
                        </BlockClicks>
                    </TableCell>
                </If>
            </Feature>
        </TableRow>
    )

    async function removeAsset() {
        if (
            await confirm(
                "Are you sure you want to permanently remove this asset from the register?",
                "Irreversible Action"
            )
        ) {
            await busyWhile(
                async () => updateAssetRegister({ registerId: register, removeAssets: [item.id] }),
                "Removing Asset"
            )
            refresh()
        }
    }

    async function editAsset() {
        const regimeParameter = regime?.id ? `?regime=${regime.id}` : ""
        navigate(`/app/asset/${uniqueId(item.id)}${regimeParameter}`)
    }
}
